<app-top-navbar [title]="'profile-form.profile' | translate"/>
<div class="wrapper">
  <app-loyalty-club-header/>
  <div class="content">
    @if (showConsentsForm$ | async) {
      <app-consent-form/>
    }
    @if (showPropertiesForm$ | async) {
      <form [class.submitted]="submitted()">
        <app-properties-form #propertiesComponent
                             [properties]="properties"
                             [propertyNames]="(missingPropertyNames$ | async ) || []"
                             [isForcedUpdate]="true"
                             [formErrors]="formErrors()"/>
        <button type="button"
                class="btn btn-lg btn-raised btn-primary btn-block"
                [disabled]="propertiesComponent.form.errors"
                (click)="onSubmitProperties()">
          <span>{{ 'profiles.edit.submit_button' | translate }}</span>
        </button>
      </form>
    }
  </div>
</div>
